import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
let TimeTemplateSelectComponent = class TimeTemplateSelectComponent extends Vue {
    value;
    selectTimeTemplate(timeTemplate) {
        return timeTemplate;
    }
    get customTimeTemplateOption() {
        return {
            value: {
                deltas: [{ delta: 3600 }, { delta: 86400 }],
                label: this.$t('Custom').toString(),
                isDefault: false,
            },
            text: this.$t('Custom').toString(),
        };
    }
    get defaultTimeTemplateOption() {
        return {
            value: {
                label: this.$t('Do not notify').toString(),
                isDefault: false,
                deltas: [],
            },
            text: this.$t('Do not notify').toString(),
        };
    }
    addDefaultTemplates(slot) {
        const newItems = slot.items.map(item => ({ value: item, text: item.label }));
        return {
            ...slot,
            items: newItems,
        };
    }
};
__decorate([
    Prop({ required: true, default: null })
], TimeTemplateSelectComponent.prototype, "value", void 0);
__decorate([
    Emit('input')
], TimeTemplateSelectComponent.prototype, "selectTimeTemplate", null);
TimeTemplateSelectComponent = __decorate([
    Component({
        name: 'time-template-select',
    })
], TimeTemplateSelectComponent);
export default TimeTemplateSelectComponent;
